// import { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { PDFViewer, pdf } from '@react-pdf/renderer';
// import  PurOrderData  from '../data/PurOrderData'; // Adjust path as per your project structure
// import QuotationDocument from '../components/PurOrderDocumentFormat/PurOrderDocument'; // Adjust path as per your project structure
// import { Box, CircularProgress, Typography, Button, Tooltip, Menu, MenuItem, ListItemIcon } from '@mui/material';
// import { Email, WhatsApp } from '@mui/icons-material';
// import ShareIcon from '@mui/icons-material/Share';

// const PurOrderViewPage = ({ loggedInUser, companyData, connectionString }) => {
//   const { quotationId } = useParams();
//   const [quota, setQuota] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   useEffect(() => {
//     const fetch = async () => {
//       try {
//         const data = await PurOrderData(quotationId, connectionString);
//         setQuota(data);
//       } catch (err) {
//         setError('Failed to load quotation.');
//         console.error('Error fetching quotation:', err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetch();
//   }, [quotationId]);

//   const handleClick = (event) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);

//   const sharePDF = async (quota, target = 'whatsapp') => {
//     try {
//       const blob = await pdf(<QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={companyData} />).toBlob();
//       const safeFirmName = quota.companyName.replace(/[^a-z0-9]/gi, '_');
//       const fileName = `${quota.invoiceNo}_${safeFirmName}.pdf`;
//       const file = new File([blob], fileName, { type: 'application/pdf' });

//       if (target === 'whatsapp' && navigator.canShare && navigator.canShare({ files: [file] })) {
//         await navigator.share({
//           title: `Quotation ${quota.invoiceNo}`,
//           text: `Please check the attached quotation for ${quota.companyName}`,
//           files: [file],
//         });
//         return;
//       }

//       if (window.showSaveFilePicker) {
//         const handle = await window.showSaveFilePicker({
//           suggestedName: fileName,
//           types: [{ description: 'PDF Document', accept: { 'application/pdf': ['.pdf'] } }],
//         });
//         const writable = await handle.createWritable();
//         await writable.write(blob);
//         await writable.close();
//         alert(`PDF saved locally as ${fileName}`);
//         return;
//       }

//       const url = URL.createObjectURL(file);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = fileName;
//       a.click();
//       URL.revokeObjectURL(url);

//       if (target === 'whatsapp') {
//         alert(`PDF downloaded as ${fileName}.\nAttach it manually in WhatsApp chat.`);
//       } else if (target === 'email') {
//         window.location.href = `mailto:${quota.toEmail}?subject=Quotation ${quota.invoiceNo}&body=Please find attached quotation PDF.`;
//       }
//     } catch (err) {
//       console.error('Share failed:', err);
//       alert('Failed to share PDF.');
//     }
//   };

//   if (loading) {
//     return (
//       <Box display='flex' justifyContent='center' alignItems='center' height='100vh'>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box p={4}>
//         <Typography color='error'>{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ position: 'relative', width: '100%', height: '100vh' }}>
//       <Tooltip title='Share' arrow>
//         <Button
//           onClick={handleClick}
//           sx={{
//             position: 'fixed',
//             top: 18,
//             right: 165,
//             zIndex: 10,
//             minWidth: 38,
//             height: 38,
//             borderRadius: '50%',
//             '&:hover': {
//               bgcolor: 'grey.700',
//               boxShadow: '0 0 12px 3px white',
//             },
//           }}
//         >
//           <ShareIcon sx={{ fontSize: 22, color: 'white' }} />
//         </Button>
//       </Tooltip>

//       <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
//         <MenuItem
//           onClick={() => {
//             handleClose();
//             sharePDF(quota, 'whatsapp');
//           }}
//           sx={{ '&:hover': { bgcolor: 'rgba(37, 211, 102, 0.1)' } }}
//         >
//           <ListItemIcon>
//             <WhatsApp sx={{ color: '#25D366' }} />
//           </ListItemIcon>
//           WhatsApp
//         </MenuItem>
//         <MenuItem
//           onClick={() => {
//             handleClose();
//             sharePDF(quota, 'email');
//           }}
//           sx={{ '&:hover': { bgcolor: 'rgba(234, 67, 53, 0.1)' } }}
//         >
//           <ListItemIcon>
//             <Email sx={{ color: '#EA4335' }} />
//           </ListItemIcon>
//           Email
//         </MenuItem>
//       </Menu>

//       <Box sx={{ width: '100%', height: '100%' }}>
//         <PDFViewer width='100%' height='100%'>
//           <QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={companyData} />
//         </PDFViewer>
//       </Box>
//     </Box>
//   );
// };

// export default PurOrderViewPage;





import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import  PurOrderData  from '../data/PurOrderData';
import QuotationDocument from '../components/PurOrderDocumentFormat/PurOrderDocument';
import { Box, CircularProgress, Typography, Button, Tooltip, Menu, MenuItem, ListItemIcon, } from "@mui/material";
import { Email, WhatsApp } from "@mui/icons-material";
import ShareIcon from "@mui/icons-material/Share";

const PurOrderViewPage = ({ loggedInUser, companyData, connectionString }) => {
  
  const { quotationId } = useParams();
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  console.log("companyId: ", companyData);
  const companyId = companyData?.[0]?.CompId;
  const company = Array.isArray(companyData) ? companyData[0] : companyData;

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await PurOrderData(quotationId, connectionString, companyId);
        setQuota(data);
      } catch (err) {
        setError("Failed to load Purchase Order.");
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [quotationId]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // ? Unified share/download logic
  const sharePDF = async (quota, target = "whatsapp") => {
    try {
      const blob = await pdf( <QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={companyData} connectionString={connectionString} />).toBlob();

      // ? Filename: QuotationNo_FirmName.pdf
      const safeFirmName = quota.companyName.replace(/[^a-z0-9]/gi, "_");
      const fileName = `${quota.invoiceNo}_${safeFirmName}.pdf`;

      const file = new File([blob], fileName, { type: "application/pdf" });

      // 1?? If sharing to WhatsApp and navigator.share is supported ? Direct Share
      if (target === "whatsapp" && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: `Quotation ${quota.invoiceNo}`,
          text: `Please check the attached quotation for ${quota.companyName}`,
          files: [file],
        });
        return;
      }

      // 2?? If File System Access API available ? Save As dialog
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [{ description: "PDF Document", accept: { "application/pdf": [".pdf"] } }],
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        alert(`? Saved locally as ${fileName}`);
        return;
      }

      // 3?? Fallback ? force browser download
      const url = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);

      if (target === "whatsapp") {
        alert(`?? PDF downloaded as ${fileName}.\nAttach it manually in WhatsApp chat.`);
      } else if (target === "email") {
        window.location.href = `mailto:${quota.toEmail}?subject=Quotation ${quota.invoiceNo}&body=Please find attached quotation PDF.`;
      }
    } catch (err) {
      console.error("Share failed:", err);
      alert("Failed to share PDF.");
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
      <Tooltip title="Share" arrow>
        <Button
          onClick={handleClick}
          sx={{
            position: "fixed",
            top: 18,
            right: 165,
            zIndex: 10,
            minWidth: 38,
            height: 38,
            borderRadius: "50%",
            "&:hover": {
              bgcolor: "grey.700",
              boxShadow: "0 0 12px 3px white",
            },
          }}
        >
          <ShareIcon sx={{ fontSize: 22, color: "white" }} />
        </Button>
      </Tooltip>

      {/* Dropdown Menu */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            sharePDF(quota, "whatsapp");
          }}
          sx={{ "&:hover": { bgcolor: "rgba(37, 211, 102, 0.1)" } }}
        >
          <ListItemIcon>
            <WhatsApp sx={{ color: "#25D366" }} />
          </ListItemIcon>
          WhatsApp
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            sharePDF(quota, "email");
          }}
          sx={{ "&:hover": { bgcolor: "rgba(234, 67, 53, 0.1)" } }}
        >
          <ListItemIcon>
            <Email sx={{ color: "#EA4335" }} />
          </ListItemIcon>
          Email
        </MenuItem>
      </Menu>

      {/* PDF Viewer */}
      <Box sx={{ width: "100%", height: "100%" }}>
        <PDFViewer width="100%" height="100%">
          <QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={company} connectionString={connectionString} />
        </PDFViewer>
      </Box>
    </Box>
  );
};

export default PurOrderViewPage;
